import PropTypes from 'prop-types';

const seam = {
  fill: 'none',
  stroke: '#9b9b9b',
  strokeWidth: 1.4,
  strokeDasharray: '3 3',
  vectorEffect: 'non-scaling-stroke',
};

const outline = {
  stroke: '#111111',
  strokeWidth: 2.7,
  strokeLinejoin: 'round',
  strokeLinecap: 'round',
  vectorEffect: 'non-scaling-stroke',
};

const collar = {
  fill: '#efefef',
  stroke: '#111111',
  strokeWidth: 1.8,
  vectorEffect: 'non-scaling-stroke',
};

const TEMPLATE_VIEWBOX = {
  tshirt: '0 0 420 520',
  hoody: '0 0 420 540',
};

const TshirtTemplate = ({ fill, view, showDetails }) => {
  const isBack = view === 'back';
  const isSleeveLeft = view === 'sleeveLeft';
  const isSleeveRight = view === 'sleeveRight';
  const isNeckLabel = view === 'neckLabelInner';

  if (isSleeveLeft || isSleeveRight) {
    const flip = isSleeveRight ? 'scale(-1 1) translate(-420 0)' : undefined;
    return (
      <g transform={flip}>
        <path
          d="M108 132l146-54 72 74-52 98-152-55-38-47c-6-8-1-14 24-16z"
          fill={fill}
          {...outline}
        />
        {showDetails && <path d="M118 145l135 49M269 91l-39 103M283 143l-38 71" {...seam} />}
        <path d="M118 151l24 29 117 42" fill="none" stroke="#111111" strokeWidth="1.2" vectorEffect="non-scaling-stroke" />
      </g>
    );
  }

  if (isNeckLabel) {
    return (
      <>
        <path
          d="M120 118c18-58 52-84 90-84s72 26 90 84v250H120V118z"
          fill={fill}
          {...outline}
        />
        <path
          d="M159 112c8 48 94 48 102 0l-20-14c-10 20-21 29-31 29s-21-9-31-29l-20 14z"
          {...collar}
        />
        {showDetails && <path d="M174 112c9 24 63 24 72 0" {...seam} />}
        <path
          d="M172 151h76v58h-76z"
          fill="#f7f7f7"
          stroke="#111111"
          strokeWidth="1.6"
          vectorEffect="non-scaling-stroke"
        />
        {showDetails && <path d="M188 170h44M188 187h44" {...seam} />}
      </>
    );
  }

  return (
    <>
      <path
        d="M176 64c6 19 22 31 34 31s28-12 34-31l86 23 78 83-48 58-40-19v258H90V209l-40 19-48-58 78-83 96-23z"
        fill={fill}
        {...outline}
      />
      {showDetails && (
        <>
          <path
            d="M90 209c25-39 36-76 34-113M330 209c-25-39-36-76-34-113"
            {...seam}
          />
          <path d="M32 177l48 42M388 177l-48 42" {...seam} />
          <path d="M91 445h238" {...seam} />
        </>
      )}
      {showDetails && (isBack ? (
        <>
          <path d="M173 59c10 25 64 25 74 0" {...collar} fill={fill} />
          <path d="M183 74c18 10 36 10 54 0" {...seam} />
        </>
      ) : (
        <>
          <path
            d="M170 62c7 43 73 43 80 0l-17-6c-8 21-17 31-23 31s-15-10-23-31l-17 6z"
            {...collar}
            fill={fill}
          />
          <path d="M184 63c7 24 45 24 52 0" {...seam} />
        </>
      ))}
      {showDetails && <path d="M154 69c15 28 35 42 56 42s41-14 56-42" {...seam} />}
    </>
  );
};

const HoodyTemplate = ({ fill, view, showDetails }) => {
  const isBack = view === 'back';
  const isSleeveLeft = view === 'sleeveLeft';
  const isSleeveRight = view === 'sleeveRight';
  const isNeckLabel = view === 'neckLabelInner';

  if (isSleeveLeft || isSleeveRight) {
    const flip = isSleeveRight ? 'scale(-1 1) translate(-420 0)' : undefined;
    return (
      <g transform={flip}>
        <path
          d="M106 118l126-52 83 78-43 208-59-12 23-124-116-48-34-36c-8-8-2-14 20-14z"
          fill={fill}
          {...outline}
        />
        {showDetails && <path d="M117 132l111 45M247 83l-27 93M235 217l54 12" {...seam} />}
      </g>
    );
  }

  if (isNeckLabel) {
    return (
      <>
        <path
          d="M145 116c8-56 34-86 65-86s57 30 65 86v252H145V116z"
          fill={fill}
          {...outline}
        />
        <path
          d="M177 102c11 18 55 18 66 0l16 25c-25 24-73 24-98 0l16-25z"
          {...collar}
        />
        <path
          d="M172 153h76v58h-76z"
          fill="#f7f7f7"
          stroke="#111111"
          strokeWidth="1.6"
          vectorEffect="non-scaling-stroke"
        />
        {showDetails && <path d="M188 172h44M188 189h44" {...seam} />}
      </>
    );
  }

  return (
    <>
      <path
        d="M116 112c-20 15-35 37-44 66L30 332l58 14 29-90v216h186V256l29 90 58-14-42-154c-9-29-24-51-44-66l-54-34h-80l-54 34z"
        fill={fill}
        {...outline}
      />
      {showDetails && (
        <>
          <path d="M117 455h186" {...seam} />
          <path d="M88 346l29-90c15-39 20-88 8-123M332 346l-29-90c-15-39-20-88-8-123" {...seam} />
        </>
      )}
      {isBack ? (
        <>
          <path
            d="M146 112c8-55 34-82 64-82s56 27 64 82c-15 27-113 27-128 0z"
            fill={fill}
            {...outline}
          />
          {showDetails && <path d="M162 105c18 23 78 23 96 0" {...seam} />}
        </>
      ) : (
        <>
          <path
            d="M146 116c5-58 33-86 64-86s59 28 64 86c-22 35-106 35-128 0z"
            fill={fill}
            {...outline}
          />
          {showDetails && (
            <path
              d="M177 100c11 18 55 18 66 0l16 25c-25 24-73 24-98 0l16-25z"
              {...collar}
            />
          )}
          {showDetails && <path d="M194 135v92M226 135v92" {...seam} />}
          <path
            d="M130 333c24-18 136-18 160 0v64c-27 13-133 13-160 0v-64z"
            fill="rgba(0,0,0,0.035)"
            stroke="#111111"
            strokeWidth="1.6"
            vectorEffect="non-scaling-stroke"
          />
          {showDetails && <path d="M158 342l-27 36M262 342l27 36" {...seam} />}
        </>
      )}
    </>
  );
};

const TEMPLATE_COMPONENTS = {
  tshirt: TshirtTemplate,
  hoody: HoodyTemplate,
};

const StudioGarmentSvg = ({ productType, view, fill, className = '', showDetails = true }) => {
  const Template = TEMPLATE_COMPONENTS[productType] || TshirtTemplate;
  const viewBox = TEMPLATE_VIEWBOX[productType] || TEMPLATE_VIEWBOX.tshirt;

  return (
    <svg
      viewBox={viewBox}
      className={className}
      aria-hidden="true"
      role="presentation"
    >
      <Template fill={fill} view={view} showDetails={showDetails} />
    </svg>
  );
};

TshirtTemplate.propTypes = {
  fill: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  showDetails: PropTypes.bool.isRequired,
};

HoodyTemplate.propTypes = {
  fill: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  showDetails: PropTypes.bool.isRequired,
};

StudioGarmentSvg.propTypes = {
  productType: PropTypes.string.isRequired,
  view: PropTypes.string.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
  showDetails: PropTypes.bool,
};

export default StudioGarmentSvg;
